require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = Xp64
// module chunks = 0